import { render, staticRenderFns } from "./StructureViewerMSA.vue?vue&type=template&id=5ebf1757&scoped=true"
import script from "./StructureViewerMSA.vue?vue&type=script&lang=js"
export * from "./StructureViewerMSA.vue?vue&type=script&lang=js"
import style0 from "./StructureViewerMSA.vue?vue&type=style&index=0&id=5ebf1757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf1757",
  null
  
)

export default component.exports